import { App } 		from 'vue'
import tmStore    	from './store'

export default {
	install: (app: App) => {
		app.config.globalProperties.$store.registerModule('tm', tmStore)
	}
}